const support = {
    heading: 'Support',
    mainContent: [

        {
            title: 'Chat and Email Support',
            sub: 'Yes'
        },
        {
            title: 'Elite Customer Support',
            sub: 'No'
        },
        {
            title: 'Onboarding and Setup Support',
            sub: 'Unlimited'
        }
    ]
}
const trackingTool = {
    heading: 'Tracking Tools',
    mainContent: [

        {
            title: 'Monthly Tracking ',
            sub: 'Unlimited'
        },
        {
            title: 'Product ID Tracking ',
            sub: 'Yes'
        },
        {
            title: 'Coupon code Tracking',
            sub: 'Yes'
        },
        {
            title: 'Fraud Prevention',
            sub: 'Yes'
        },
        {
            title: 'Sales Goal tracking',
            sub: 'Yes'
        }
    ]
}
const reporting = {
    heading: 'Reporting',
    mainContent: [

        {
            title: 'Real Time Reporting ',
            sub: 'Unlimited'
        },
        {
            title: 'Daily Reporting ',
            sub: 'Yes'
        },
        {
            title: 'Monthly Reporting',
            sub: 'Yes'
        }
    ]
}
const collaboration = {
    heading: 'Collaboration',
    mainContent: [

        {
            title: 'Affiliates ',
            sub: 'Unlimited'
        },
        {
            title: 'In-App Messaging ',
            sub: 'Yes'
        },
        {
            title: 'Account Managers',
            sub: 'Unlimited'
        },
        {
            title: 'Free 50+ Integrations',
            sub: 'Yes'
        }
    ]
}
const campaigns = {
    heading: 'Campaigns, Payments  & Customization',
    mainContent: [

        {
            title: 'Fraud Prevention and Control Tools',
            sub: 'Yes'
        },
        {
            title: 'Custom Affiliate Onboarding ',
            sub: 'Yes'
        },
        {
            title: 'Single Access (MA)',
            sub: 'Yes'
        },
        {
            title: 'Language Customization',
            sub: '5',
            color: "#05C786"
        },
        {
            title: 'Custom Themes',
            sub: 'Yes'
        },
        {
            title: 'Active Campaigns',
            sub: 'Unlimited'
        },
        {
            title: 'Clicks',
            sub: 'Unlimited'
        },
        {
            title: 'Clicks Overage Fee ',
            sub: '-'
        },
        {
            title: 'Conversions/Customers',
            sub: 'Unlimited'
        },
        {
            title: 'Conversions/Customers Overage Fee ',
            sub: ''
        },
        {
            title: 'Recurring commissions ',
            sub: 'Yes'
        },
        {
            title: 'Mass Payment',
            sub: 'Yes'
        },
        {
            title: 'Early Access to New Features',
            sub: 'Yes'
        },
        {
            title: 'Cookie Controls',
            sub: 'Yes'
        },
        {
            title: 'Free Transaction Fee',
            sub: 'Yes'
        },
        {
            title: 'Referral Commission (MLM)',
            sub: 'Yes'
        },
        {
            title: 'Direct Social Sharing',
            sub: 'Yes'
        },
    ]
}

export { campaigns, support, collaboration, reporting, trackingTool }